<template>
  <a-modal
    width="1000px"
    :visible="visible"
    title="新建店务运营目标"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="保存"
  >
    <a-button type="primary" style="float: right" @click="() => handleAddItem()">增加</a-button>
    <a-table
      :scroll="{ y: 400 }"
      :columns="columns"
      row-key="id"
      :data-source="datasource"
      :pagination="false"
    >
      <template #index="{ record, index }">
        {{ index + 1 }}
      </template>
      <template #date="{ record }">
        <a-date-picker
          v-model:value="record.date"
          picker="month"
          placeholder="请选择月份"
          :format="'YYYY-MM'"
          :value-format="'YYYY-MM-01'"
          @change="v => changeDate(v, record)"
        />
      </template>
      <template #shop_id="{ record }">
        <a-select
          v-model:value="record.shop_id"
          placeholder="请选择门店"
          @change="v => changeShop(v, record)"
        >
          <a-select-option :value="item.id" v-for="item in sourceShopDatasource">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template
        v-for="col in ['cz_target_count', 'hl_target_amount', 'cp_target_amount']"
        #[col]="{ record }"
        :key="col"
      >
        <a-input-number v-model:value="record[col]" style="margin: -5px 0" min="0" />
      </template>
      <template #action="{ record, index }">
        <a-button type="danger" @click="() => handleDeleteItem(record, index)">删除</a-button>
      </template>
    </a-table>
  </a-modal>
</template>

<script lang="ts">
import { createVNode, defineComponent, onMounted, ref } from 'vue';
import { message, Modal, notification } from 'ant-design-vue';
import { reactive } from 'vue';
import { query_shop_list } from '@/api/mjstore-model';
import {
  bulk_create_shop_operation_target,
  query_shop_operation_target_list,
} from '@/api/mjstat-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { h } from 'vue';
export default defineComponent({
  name: 'Shopoperationtargetmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    onMounted(() => {
      init();
    });
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const loading = ref(false);
    const sourceShopDatasource: Array<any> = reactive([]);
    const datasource: Array<any> = reactive([]);
    const columns: Array<any> = reactive([
      {
        title: '序号',
        width: 60,
        dataIndex: 'index',
        checked: true,
        slots: { customRender: 'index' },
      },
      {
        title: '月份',
        width: 150,
        dataIndex: 'date',
        checked: true,
        slots: { customRender: 'date' },
      },
      {
        title: '门店',
        width: 150,
        dataIndex: 'shop_id',
        checked: true,
        slots: { customRender: 'shop_id' },
      },
      {
        title: '操作目标数',
        width: 150,
        dataIndex: 'cz_target_count',
        checked: true,
        slots: { customRender: 'cz_target_count' },
      },
      {
        title: '护理目标金额',
        width: 150,
        dataIndex: 'hl_target_amount',
        checked: true,
        slots: { customRender: 'hl_target_amount' },
      },
      {
        title: '产品目标金额',
        width: 150,
        dataIndex: 'cp_target_amount',
        checked: true,
        slots: { customRender: 'cp_target_amount' },
      },
      {
        title: '操作',
        width: 100,
        dataIndex: 'action',
        checked: true,
        slots: { customRender: 'action' },
      },
    ]);
    const init = () => {
      getShopData();
    };
    const queryShopOperationTargetList = (date: any, shop_ids: any) => {
      query_shop_operation_target_list({
        org_id: current_org.id,
        shop_ids: shop_ids,
        date: date,
      }).then((res: any) => {
        res.data.forEach((item: any) => {
          datasource.forEach(obj => {
            if (item.shop_id == obj.shop_id && item.date == obj.date) {
              obj.cz_target_count = item.cz_target_count;
              obj.hl_target_amount = item.hl_target_amount;
              obj.cp_target_amount = item.cp_target_amount;
            }
          });
        });
      });
    };

    const getShopData = () => {
      query_shop_list({
        org_id: current_org.id,
        page_index: 1,
        pageSize: 2000,
        is_active: true,
      }).then((res: any) => {
        sourceShopDatasource.length = 0;
        res.data.forEach((item: any) => {
          if (
            item.shop_type__name == '医美门店' ||
            item.shop_type__name == '生美门店' ||
            item.shop_type__name == '康养门店'
          ) {
            sourceShopDatasource.push(item);
          }
        });
        datasource.length = 0;
        const date = moment().format('YYYY-MM-01');
        res.data.forEach((item: any) => {
          if (
            item.shop_type__name == '医美门店' ||
            item.shop_type__name == '生美门店' ||
            item.shop_type__name == '康养门店'
          ) {
            datasource.push({
              date,
              shop_id: item.id,
              shop__name: item.name,
              cz_target_count: null,
              hl_target_amount: null,
              cp_target_amount: null,
            });
          }
        });
        const shop_ids = datasource.map(item => {
          if (!item.shop_id) {
            return item.shop_id;
          }
        });
        queryShopOperationTargetList(date, shop_ids);
      });
    };

    const changeDate = (date: any, record: any) => {
      record.cz_target_count = null;
      record.hl_target_amount = null;
      record.cp_target_amount = null;
      queryShopOperationTargetList(date, record.shop_id);
    };
    const changeShop = (shop_ids: any, record: any) => {
      record.cz_target_count = null;
      record.hl_target_amount = null;
      record.cp_target_amount = null;
      queryShopOperationTargetList(record.date, shop_ids);
    };

    const handleDeleteItem = (record: any, index: number) => {
      datasource.splice(index, 1);
    };
    const handleAddItem = () => {
      datasource.push({
        date: moment().format('YYYY-MM-01'),
        shop_id: null,
        shop__name: null,
        cz_target_count: null,
        hl_target_amount: null,
        cp_target_amount: null,
      });
      setTimeout(() => {
        const el = (document as any).querySelector('div.ant-table-body');
        el.scrollTop = el.scrollHeight;
      }, 100);
    };
    const handleCancel = () => {
      emit('cancel');
    };

    const handleOk = () => {
      let is_ok = true;
      let is_confirm = false;
      let msg = '';
      let msg_list: any = [];
      let list: any = [];
      datasource.some((item, i) => {
        if (!item.date) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}条数据缺少月份。`);
        } else if (!item.shop_id) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}条数据缺少门店。/n`);
        } else if (!item.cz_target_count) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}条数据缺少【操作目标数】。`);
        } else if (!item.hl_target_amount) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}条数据缺少【护理目标金额】。`);
        } else if (!item.cp_target_amount) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}条数据缺少【产品目标金额】。`);
        } else {
          list.push(item);
        }
        datasource.some((obj, j) => {
          if (i != j && item.shop_id == obj.shop_id && item.date == obj.date) {
            is_ok = false;
            msg = `请确认数据，第${i + 1}条数据与第${j + 1}条【月份:${item.date},门店${
              item.shop__name
            }】数据重复。`;
          }
        });
        if (!is_ok) {
          return true;
        }
      });
      if (!is_ok) {
        message.warning(msg);
        return;
      }
      if (list.length == 0) {
        message.warning('提交的数据不能为空');
        return;
      }
      if (is_confirm) {
        Modal.confirm({
          title: `是否忽略缺填数据，仍然提交？`,
          content: h('pre', `${msg_list.join('\n')}`),
          icon: createVNode(ExclamationCircleOutlined),
          onOk() {
            submit_fun(list);
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onCancel() {},
        });
      } else {
        submit_fun(list);
      }
    };
    const submit_fun = (list: any) => {
      bulk_create_shop_operation_target({
        org_id: current_org.id,
        shop_operation_target_json: JSON.stringify(list),
      }).then((res: any) => {
        notification.success({
          message: '成功',
          description: '创建成功',
        });
        emit('ok');
        event_obj.emit('refresh');
        loading.value = false;
      });
    };

    return {
      message,
      loading,
      columns,
      sourceShopDatasource,
      datasource,
      handleDeleteItem,
      handleAddItem,
      handleCancel,
      handleOk,
      changeShop,
      changeDate,
    };
  },
});
</script>
